module.exports = __webpack_public_path__ + "img/btn-ios.e1d655ab.png";